module.exports = __webpack_public_path__ + "media/images/default/shared/right-arrow-b793a98837a25a3f8a22c42675b8859f.svg";